import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=ff34ecaa&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=ff34ecaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff34ecaa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff34ecaa')) {
      api.createRecord('ff34ecaa', component.options)
    } else {
      api.reload('ff34ecaa', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=ff34ecaa&scoped=true&", function () {
      api.rerender('ff34ecaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2daTfQAa9lAtb/JS/comp/PopupDialog.vue"
export default component.exports